import { LinkableEntityType } from '@api';
import {
  ArtistAnchor,
  CompanyAnchor,
  FestivalAnchor,
  PersonAnchor,
  TourAnchor,
  VenueAnchor,
} from '@common';

type LinkableEntityPropsType = { linkableEntity: LinkableEntityType };

export const LinkableEntity: React.FC<LinkableEntityPropsType> = ({
  linkableEntity,
}) => {
  switch (linkableEntity.type) {
    case 'ARTIST':
      return <ArtistAnchor artist={linkableEntity} />;
    case 'TOUR':
      return <TourAnchor tour={linkableEntity} />;
    case 'VENUE':
      return <VenueAnchor venue={linkableEntity} />;
    case 'FESTIVAL':
      return <FestivalAnchor festival={linkableEntity} />;
    case 'COMPANY':
      return <CompanyAnchor company={linkableEntity} />;
    case 'PERSON':
      return <PersonAnchor person={linkableEntity} />;
    default:
      return null;
  }
};
